import { toast } from "./toast";

/**
 * Copia al portapapeles y avisa el resultado.
 *
 * `navigator.clipboard` no existe fuera de un contexto seguro (http sin TLS, algunos
 * webviews). Encadenar `.then` sobre `navigator.clipboard?.writeText(...)` revienta
 * justo en ese caso, y el comercio se queda sin forma de llevarse un secreto que no
 * se vuelve a mostrar: por eso el error se atrapa y se le pide copiarlo a mano.
 */
export async function copyToClipboard(value, successMessage, t) {
  try {
    if (!navigator.clipboard) throw new Error("Portapapeles no disponible");
    await navigator.clipboard.writeText(value);
    toast.success(successMessage);
  } catch {
    toast.error(t("No se pudo copiar. Selecciona el texto y cópialo a mano."));
  }
}
